import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Index from './components/Home/Index';
import Products from './components/Products/Index';
import ProductsDetail from './components/Products/ProductDetail/Index';
import Cart from './components/Cart/Index';
import Checkout from './components/Cart/Checkout';
import ScrollToTop from './components/ScrollToTop';
import Account from './components/Account/Index';
import WishlistPage from './components/Account/Wishlist/WishlistPage';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Toaster position="top-center" />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:productId" element={<ProductsDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/settings" element={<Account />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Routes>
    </Router>
  );
}



export default App;
